<template>
  <div class="grid grid-cols-1 gap-8 w-full lg:grid-cols-3">
    <div
      v-for="(tool, index) in tools"
      :key="index"
      class="flex flex-col w-full border border-gray-200 rounded-lg shadow bg-[linear-gradient(180deg,_#FCFCFD_0%,_#F9FAFB_100%)]"
    >
      <div class="flex flex-col gap-1 p-6">
        <h1 class="text-2xl font-medium text-gray-900">
          {{ tool.name }}
        </h1>
        <p class="text-gray-700">
          {{ tool.description }}
        </p>
      </div>
      <img
        :src="tool.image"
        alt="tool-img"
        class="object-cover w-full h-40 sm:h-[244px]"
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { shallowRef } from "vue";
import Variables from "@/../images/tabbed-bento-images/variables/variables.svg";
import Preview from "@/../images/tabbed-bento-images/variables/preview.svg";
import SetUpImage from "@/../images/tabbed-bento-images/variables/set-up.svg";

const tools = shallowRef([
    {
        name: "Variables",
        description:
            "Layers provide freedom to experiment with text, images, or shapes. Explore various arrangements to find your perfect balance.",
        image: Variables,
    },
    {
        name: "Preview",
        description:
            "Experiment with fonts, sizes, and colors to achieve the perfect look every time with our user-friendly editor. Your text, your way!",
        image: Preview,
    },
    {
        name: "Easy to set up",
        description:
            "Adjust your postcard's text by selecting or creating boxes. Add a personal touch to your design.",
        image: SetUpImage,
    },
]);
</script>
